import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { HOME } from "@/constants/testIds";
import { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed.");
    } finally { setBusy(false); }
  };

  return (
    <section className="mx-auto max-w-[1200px] px-5 md:px-10 py-14 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-10">
      <div className="md:col-span-6 md:pr-10">
        <div className="eyebrow">The Portal</div>
        <h1 className="font-serif-ev mt-4 text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-tight">
          Return to your <span className="italic" style={{ color: "var(--ev-blue-2)" }}>practice</span>.
        </h1>
        <p className="mt-6 text-[15px] max-w-md" style={{ color: "var(--ev-muted)" }}>
          Your sessions, journal prompts and resources — kept in one quiet room.
        </p>
      </div>
      <form onSubmit={submit} className="md:col-span-6 md:col-start-7 ev-card p-7 md:p-10">
        <div className="eyebrow">Sign in</div>
        <div className="font-serif-ev text-3xl mt-1">Welcome back.</div>
        <div className="mt-7 space-y-5">
          <div>
            <label className="text-xs uppercase tracking-widest" style={{ color: "var(--ev-muted)" }}>Email</label>
            <input data-testid={HOME.loginEmail} required type="email" value={email}
                   onChange={(e) => setEmail(e.target.value)}
                   className="mt-2 w-full bg-white border hairline rounded-full py-3 px-4 focus:outline-none focus:border-[color:var(--ev-blue-2)] text-[15px]" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest" style={{ color: "var(--ev-muted)" }}>Password</label>
            <input data-testid={HOME.loginPassword} required type="password" value={password}
                   onChange={(e) => setPassword(e.target.value)}
                   className="mt-2 w-full bg-white border hairline rounded-full py-3 px-4 focus:outline-none focus:border-[color:var(--ev-blue-2)] text-[15px]" />
          </div>
        </div>
        <button data-testid={HOME.loginSubmit} disabled={busy} type="submit"
                className="mt-8 ev-btn ev-btn-primary w-full disabled:opacity-60">
          {busy ? "Signing in…" : "Enter the Portal"} <ArrowRight className="w-4 h-4" />
        </button>
        <div className="mt-6 text-sm" style={{ color: "var(--ev-muted)" }}>
          New here? <Link to="/register" className="underline" style={{ color: "var(--ev-ink)" }}>Create an account</Link>
        </div>
      </form>
    </section>
  );
}
